import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { format, addDays, startOfWeek, endOfWeek, eachDayOfInterval, isSameDay } from 'date-fns';

const IntegratedCalendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const startDate = startOfWeek(currentDate);
  const endDate = endOfWeek(currentDate);
  const calendarDays = eachDayOfInterval({ start: startDate, end: endDate });

  const appointments = [
    { date: addDays(startDate, 2), title: "Strategy Review", time: "10:00 AM" },
    { date: addDays(startDate, 4), title: "Tech Stack Audit", time: "2:00 PM" }
  ];

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border border-slate-100 dark:border-slate-800 text-slate-900 dark:text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 p-8 opacity-5">
        <SafeIcon name="Calendar" className="w-32 h-32 text-brand-cyan" />
      </div>
      
      <div className="relative z-10 flex flex-col">
        <div className="flex items-center justify-between mb-8">
          <div>
            <span className="text-brand-cyan text-[10px] uppercase font-bold tracking-[0.2em] block mb-1">Upcoming Engagements</span>
            <h3 className="text-2xl font-heading font-bold">Strategy Calendar</h3>
          </div>
          <button className="p-2 bg-slate-50 dark:bg-white/5 rounded-lg hover:bg-slate-100 dark:hover:bg-white/10 transition-colors">
            <SafeIcon name="Plus" className="w-5 h-5 text-brand-cyan" />
          </button>
        </div>

        {/* Weekly View Mini-Calendar */}
        <div className="grid grid-cols-7 gap-2 mb-8">
          {calendarDays.map((day, i) => {
            const hasAppt = appointments.some(a => isSameDay(a.date, day));
            return (
              <div key={i} className="flex flex-col items-center gap-2">
                <span className="text-[9px] uppercase font-bold text-slate-500">{format(day, 'EEE')}</span>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-xs font-bold transition-all relative ${isSameDay(day, new Date()) ? 'bg-brand-cyan text-brand-dark' : 'bg-slate-50 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10'}`}>
                  {format(day, 'd')}
                  {hasAppt && <div className="absolute bottom-1 w-1 h-1 bg-brand-red rounded-full"></div>}
                </div>
              </div>
            );
          })}
        </div>

        <div className="space-y-4 flex-grow overflow-y-auto max-h-[200px] custom-scrollbar">
          {appointments.map((appt, i) => (
            <div key={i} className="flex items-center gap-4 p-4 rounded-xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 hover:border-brand-cyan/30 transition-all">
              <div className="w-10 h-10 rounded-lg bg-brand-cyan/20 flex flex-col items-center justify-center text-brand-cyan">
                <span className="text-[10px] font-black">{format(appt.date, 'MMM')}</span>
                <span className="text-xs font-black">{format(appt.date, 'd')}</span>
              </div>
              <div>
                <h4 className="text-sm font-bold">{appt.title}</h4>
                <p className="text-[10px] text-slate-400 font-medium">{appt.time} • Zoom Access</p>
              </div>
              <button className="ml-auto text-slate-500 hover:text-white transition-colors">
                <SafeIcon name="ExternalLink" className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>

        <a href="https://calendar.app.google/fEc5DqiofeUeHyRG6" target="_blank" rel="noopener noreferrer" className="block text-center w-full mt-6 py-4 bg-brand-cyan text-brand-dark text-[10px] uppercase tracking-widest font-black rounded-xl hover:bg-white transition-all shadow-lg shadow-brand-cyan/10">
          Book New Strategy Session
        </a>
      </div>
    </div>
  );
};

export default IntegratedCalendar;